<template>
<div class="chapter">
<div class="inner_page">
<div>
<svg height="100%" preserveaspectratio="xMidYMid meet" version="1.1" viewbox="0 0 547 876" width="100%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><image height="876" width="547" xlink:href="../Images/cover.jpeg"></image></svg>http://www.amazon.com/Womans-Own-Robyn-Carr-ebook/dp/B00CR4RQ8G
  </div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?4fef7022